import { render } from "./EditGrupouView.vue?vue&type=template&id=5ab47416&scoped=true"
import script from "./EditGrupouView.vue?vue&type=script&lang=js"
export * from "./EditGrupouView.vue?vue&type=script&lang=js"

import "./EditGrupouView.vue?vue&type=style&index=0&id=5ab47416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab47416"]])

export default __exports__